import React from 'react'
import {
  MaterialIcon,
  MaterialIconRef,
} from 'src/components/framework/icons/material-icon'
import { Column, Grid } from 'src/components/framework/ui'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { RatioLink } from 'src/components/page/ratios/ratios'
import { Colors } from 'src/shared/colors'

export interface Props {
  title: string
  score?: string
  id?: string
}

export const ScoreHeader: React.FC<Props> = ({ title, score, id }) => {
  return (
    <Grid alignHorizontally={'center'}>
      <Column>
        <SectionHeader spacing={0}>
          <span className={'stk-wrapper stk-wrapper--middle'}>
            <span>{title}</span>
            {score && id ? <RatioLink id={id}>({score})</RatioLink> : <></>}
          </span>
        </SectionHeader>
      </Column>
      <Column shrink={'shrink'}>
        <span
          className={
            'stk-lotto stk-lotto--neutral stk-lotto--large stk-space-in-0'
          }
        >
          <MaterialIcon
            icon={MaterialIconRef.Locker}
            size={12}
            color={Colors.White}
          />
        </span>
      </Column>
    </Grid>
  )
}
